import React from "react";
import Link from "next/link";
import { useState, useEffect, useRef } from "react";
import { useRouter } from "next/router";
import SideBanner from "./SideBanner";
import BlogSearch from "./BlogSearch";
import { convertToImageKit } from "../../utils/convert-to-imagekit";
import LazyLoad from "react-lazyload";
import styles from "../../pages/current-affairs/blog/[slug].module.scss";

const BlogSidebar = ({ language }) => {
  const [latestPosts, setLatestPosts] = useState(null);
  const [categories, setCategories] = useState(null);
  // const [search, setSearch] = useState([""]);
  const [search, setSearch] = useState("");
  const router = useRouter();

  // const scollToRef = useRef();
  // scollToRef && scollToRef.current && scollToRef.current.scrollIntoView()

  // const scrollWin = ()=> {
  //   window.scrollTo(0, 1000);
  // }

  // console.log("language:", language);

  useEffect(() => {
    const getLatestPosts = async () => {
      const url = `https://api.toppersnotes.com/api/ca/today-articles?lang=${language}`;
      let data = await fetch(url);

      let parsedData = await data.json();
      setLatestPosts(parsedData);
    };
    getLatestPosts();
  }, []);

  useEffect(() => {
    const getCategories = async () => {
      const url = `https://api.toppersnotes.com/api/ca/categories`;
      let data = await fetch(url);

      let parsedData = await data.json();
      setCategories(parsedData);
    };
    getCategories();
  }, []);

  useEffect(() => {
    const searchedValue = () => {
      return search && search.toString().toLowerCase();
    };
    searchedValue();
    // console.log("useeffect searched value:", searchedValue);
  }, []);

  // let inputHandler = (e) => {
  //   //convert input text to lower case
  //   var lowerCase = e.target.value.toLowerCase();
  //   setSearch(lowerCase);
  //   console.log("this is input text:", search);
  // };

  return (
    <div className={styles["widget-area"]}>
      <div className={`${styles.widget} ${styles["widget_search"]}`}>
        {/* <h3 className="widget-title">Search</h3> */}
        <BlogSearch language={language} />

        {/* <form className="search-form">
          <label>
            <input
              type="search"
              className="search-field"
              placeholder="Search article here..."
              value={search}
              onChange={inputHandler}
              onKeyPress={(e) => {
                e.key === "Enter" &&
                  router.push(
                    `/current-affairs/search/${search}?blog=${search}`
                  );
              }}
            />
          </label>
          <button
            type="button"
            onClick={() => router.push(`/current-affairs/search/${search}`)}
          >
            <i className="bx bx-search-alt"></i>
          </button>
        </form> */}
      </div>

      <div className={`${styles.widget} ${styles["widget_edemy_posts_thumb"]}`}>
        <h3 className={styles["widget-title"]}>
          {latestPosts && latestPosts.title}
        </h3>
        {latestPosts &&
          latestPosts.articles &&
          latestPosts.articles.map((l_posts) => {
            const img = l_posts.image;

            return (
              <div className={styles.item}>
                {language && language === "en" ? (
                  <>
                    <Link href={`/current-affairs/blog/${l_posts.slug}`}>
                      <a className={styles.thumb}>
                        <LazyLoad once>
                          <span
                            className={`${styles.fullimage} ${styles.bg1} cover`}
                            role="img"
                            style={{
                              backgroundImage: `url(${convertToImageKit(
                                img,
                                "app"
                              )})`,
                            }}
                          ></span>
                        </LazyLoad>
                      </a>
                    </Link>
                    <div className={styles.info}>
                      <span>{l_posts.date}</span>
                      <h4 className={`usmall ${styles.title}`}>
                        <Link href={`/current-affairs/blog/${l_posts.slug}`}>
                          <a>{l_posts.head}</a>
                        </Link>
                      </h4>
                    </div>

                    <div className="clear"></div>
                  </>
                ) : language === "hi" ? (
                  <>
                    <Link href={`/current-affairs/blog/hindi/${l_posts.slug}`}>
                      <a className={styles.thumb}>
                        <LazyLoad once>
                          <span
                            className={`${styles.fullimage} ${styles.bg1} cover`}
                            role="img"
                            style={{
                              backgroundImage: `url(${convertToImageKit(
                                img,
                                "app"
                              )})`,
                            }}
                          ></span>
                        </LazyLoad>
                      </a>
                    </Link>
                    <div className={styles.info}>
                      <span>{l_posts.date}</span>
                      <h4 className={`usmall ${styles.title}`}>
                        <Link
                          href={`/current-affairs/blog/hindi/${l_posts.slug}`}
                        >
                          <a>{l_posts.head}</a>
                        </Link>
                      </h4>
                    </div>

                    <div className="clear"></div>
                  </>
                ) : (
                  ""
                )}
              </div>
            );
          })}
      </div>
      <div className={`${styles.widget} ${styles["widget_categories"]}`}>
        <h3 className={`${styles["widget-title"]} flex justify-between`}>
          <span className="">Categories</span>
          <button
            type="button"
            className="text-blue-500 font-bold"
            onClick={() => {
              localStorage.setItem("blogScrol", true);
              router.push({
                pathname: "/current-affairs",
                hash: "categories",
              });
            }}
          >
            See All
          </button>
        </h3>

        <ul>
          {categories &&
            categories.slice(0, 5).map((category) => {
              return (
                <li>
                  <Link href={`/blog/${category.slug}`}>
                    <a>
                      {category && category.name}{" "}
                      <span className={styles["post-count"]}>
                        ({category && category.articles_count})
                      </span>
                    </a>
                  </Link>
                </li>
              );
            })}
          {/* <li>
            <Link href="#">
              <a>
                Design <span className="post-count">(03)</span>
              </a>
            </Link>
          </li>
          <li>
            <Link href="#">
              <a>
                Lifestyle <span className="post-count">(05)</span>
              </a>
            </Link>
          </li>
          <li>
            <Link href="#">
              <a>
                Script <span className="post-count">(10)</span>
              </a>
            </Link>
          </li>
          <li>
            <Link href="#">
              <a>
                Device <span className="post-count">(08)</span>
              </a>
            </Link>
          </li>
          <li>
            <Link href="#">
              <a>
                Tips <span className="post-count">(01)</span>
              </a>
            </Link>
          </li> */}
        </ul>
      </div>

      {/* <div className="widget widget_tag_cloud">
                <h3 className="widget-title">Popular Tags</h3>

                <div className="tagcloud">
                    <Link href="#">
                        <a>
                            Business <span className="tag-link-count"> (3)</span>
                        </a>
                    </Link>
                    
                    <Link href="#">
                        <a>
                            Design <span className="tag-link-count"> (3)</span>
                        </a>
                    </Link>
                    
                    <Link href="#">
                        <a>
                            Braike <span className="tag-link-count"> (2)</span>
                        </a>
                    </Link>

                    <Link href="#">
                        <a>
                            Fashion <span className="tag-link-count"> (2)</span>
                        </a>
                    </Link>

                    <Link href="#">
                        <a>
                            Travel <span className="tag-link-count"> (1)</span>
                        </a>
                    </Link>

                    <Link href="#">
                        <a>
                            Smart <span className="tag-link-count"> (1)</span>
                        </a>
                    </Link>

                    <Link href="#">
                        <a>
                            Marketing <span className="tag-link-count"> (1)</span>
                        </a>
                    </Link>

                    <Link href="#">
                        <a>
                            Tips <span className="tag-link-count"> (2)</span>
                        </a>
                    </Link>
                </div>
            </div> */}
      <SideBanner language={language} />
    </div>
  );
};

export default BlogSidebar;
